/* React */
import React from "react";

/* Constants */
import { SankeyBoxplotType } from "src/shared/constants/charts/Chart";

/* Stylesheet */
import styles from "./ContentContainer.module.scss";

const getContentByName = (name: string) => {
  switch (name) {
    case SankeyBoxplotType.TIME_TO_NEXT_TREATMENT:
      return (
        <div className={styles.content}>
          <h6>Time to next treatment</h6>
          <p>
            <u>Definition</u>
            <br />
            The time between the end of a treatment and the
            start of the next treatment.
          </p>
          <p>
            <u>Calculation</u>
            <br />
            <span>
              Start date of next treatment - End date of
              previous treatment
            </span>
          </p>
          <p>
            <u>Interpretation</u>
            <br />
            Serves a prozy for progression-free survival in
            observational data. Short TTNT may indicate
            early relapse or intolerance.
          </p>
        </div>
      );
    case SankeyBoxplotType.DURATION_OF_TREATMENT:
      return (
        <div className={styles.content}>
          <h6>Duration of treatment</h6>
          <p>
            <u>Definition</u>
            <br />
            The time between the start and end of a
            treatment regimen.
          </p>
          <p>
            <u>Calculation</u>
            <br />
            <span>
              End date of treatment - Start date of
              treatment
            </span>
          </p>
          <p>
            <u>Interpretation</u>
            <br />
            Measures how long a patient actively received a
            specific therapy (e.g. R-miniCHOP).
          </p>
        </div>
      );
    case SankeyBoxplotType.TIME_WITHOUT_TREATMENT:
      return (
        <div className={styles.content}>
          <h6>Time without treatment</h6>
          <p>
            <u>Definition</u>
            <br />
            The time during which the patient receives no
            systematic therapy.
          </p>
          <p>
            <u>Calculation</u>
            <br />
            <span>
              End of treatment - (either death, end of
              observation, or next treatment)
            </span>
          </p>
          <p>
            <u>Interpretation</u>
            <br />
            Can indicate treatment holidays or patient
            stability without further therapy. May reflect
            remission duration.
          </p>
        </div>
      );
    case SankeyBoxplotType.TIME_TO_TREATMENT:
      return (
        <div className={styles.content}>
          <h6>Time to treatment</h6>
          <p>
            <u>Definition</u>
            <br />
            The Time between diagnosis and the start of the
            first treatment.
          </p>
          <p>
            <u>Calculation</u>
            <br />
            <span>
              Start date of first treatment - Diagnosis date
            </span>
          </p>
          <p>
            <u>Interpretation</u>
            <br />
            Indicates how quickly treatment is initiated
            after diagnosis. Useful to assess treatment
            delays.
          </p>
        </div>
      );
  }
};

export default getContentByName;
